import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings" }
const _hoisted_2 = {
  key: 0,
  class: "pp-lottery-winnings__description"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

import { computed } from "vue";
import { PpDraw } from "@/lotteries/services/model/draw";
import { StringUtils } from "@sazka/utils/string-utils";
import PpAddonWinnings from "@/lotteries/product-page/components/results/pp-addon-winnings.vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import PpSpecialPrizeWinnings from "./pp-special-prize-winnings.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-eurojackpot-winnings',
  props: {
    results: {}
  },
  setup(__props: any) {

const props = __props;

const hasCalculatedWinnings = computed(() => {
    return props.results?.hasCalculatedWinnings;
});

const hasOtherCountryWins = (index: number) => {
    if (index < 3) {
        return !!props.results?.winsByCountry?.[index];
    }

    return false;
};

const formatWinning = (wins: number, index: number) => {
    if (index < 3) {
        return props.results?.winsByCountry?.[index];
    }

    return `Česká republika ${StringUtils.formatNumber(wins)}x`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!hasCalculatedWinnings.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Právě probíhá výpočet výher."))
      : _createCommentVNode("", true),
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        _createVNode(DsRow, null, {
          default: _withCtx(() => [
            _createVNode(DsCell, {
              type: "th",
              "data-test": "table-winnings-1-1"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Pořadí")
              ])),
              _: 1,
              __: [0]
            }),
            _createVNode(DsCell, {
              type: "th",
              "data-test": "table-winnings-2-1"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Uhodnuto")
              ])),
              _: 1,
              __: [1]
            }),
            _createVNode(DsCell, {
              type: "th",
              "data-test": "table-winnings-3-1"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Výhra")
              ])),
              _: 1,
              __: [2]
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.mainGameWinnings[0], (winning, index) => {
          return (_openBlock(), _createBlock(DsRow, { key: index }, {
            default: _withCtx(() => [
              _createVNode(DsCell, {
                "data-test": `table-winnings-1-${index + 2}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(index + 1) + ". pořadí", 1)
                ]),
                _: 2
              }, 1032, ["data-test"]),
              _createVNode(DsCell, {
                "data-test": `table-winnings-2-${index + 2}`
              }, {
                default: _withCtx(() => [
                  (winning.amount && (winning.wins || hasOtherCountryWins(index)))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("strong", {
                          innerHTML: _unref(StringUtils).formatCurrency(winning.amount)
                        }, null, 8, _hoisted_4)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("–––")
                      ], 64))
                ]),
                _: 2
              }, 1032, ["data-test"]),
              _createVNode(DsCell, {
                "data-test": `table-winnings-3-${index + 2}`
              }, {
                default: _withCtx(() => [
                  (winning.amount && (winning.wins || hasOtherCountryWins(index)))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        innerHTML: formatWinning(winning.wins, index)
                      }, null, 8, _hoisted_5))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("–––")
                      ], 64))
                ]),
                _: 2
              }, 1032, ["data-test"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.results.addonWinnings)
      ? (_openBlock(), _createBlock(PpAddonWinnings, {
          key: 1,
          lottery: _unref(Lottery).eurojackpot,
          winnings: _ctx.results.addonWinnings
        }, null, 8, ["lottery", "winnings"]))
      : _createCommentVNode("", true),
    _createVNode(PpSpecialPrizeWinnings, {
      lottery: _unref(Lottery).eurojackpot,
      specialPrizes: _ctx.results.specialPrizes
    }, null, 8, ["lottery", "specialPrizes"])
  ]))
}
}

})